import React, { useEffect, useState } from "react";
import { Form, Button, Modal, Popconfirm } from "antd";
import { ReactSVG } from "react-svg";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

import ListContainer from "../../modules/user/containers/List";
import UsersTable from "../Table/Users";
import UserForm from "../Forms/Users/User";
import InviteUserForm from "../Forms/Groups/InviteUser";
import withPage from "./withPage";
import { PAGE_SIZE } from "../../constants";
import RoutePlanCurrent from "../RoutePlan/RoutePlanCurrent";
import PrimaryButton from "../Buttons/PrimaryButton";
import { getTranslation } from "../../utils/helper";

const UsersPage = ({
  isFetching,
  isSucceeded,
  users,
  metadata,
  query,
  pushTo,
  doGetAllUsers,
  doCreateUser,
  doUpdateUser,
  doDeleteUser,
  groups,
  invite,
  doGetAllGroups,
  doUpdateGroupInviteEmail,
  doUpdateGroupDisInviteEmail,
  doGetGroupInviteEmails,
  doOffGroupInviteEmails,
}) => {
  const user = useSelector(state => state.auth.user);
  const setting = user.company;

  const [form] = Form.useForm();
  const currentPage = Number(query.currentPage) || 1;
  const itemsPerPage = Number(query.itemsPerPage) || PAGE_SIZE;
  const pagination = {
    current: currentPage,
    pageSize: itemsPerPage,
    total: metadata.totalItems,
    showTotal: total => `${total} ${getTranslation(setting, "Users", "Users")}`,
  };
  const [state, setState] = useState({
    visibleModal: false,
    action: "",
    type: "",
    user: null,
  });

  const [hidePopup, setHidePopup] = useState(false);

  useEffect(() => {
    if (!isFetching && isSucceeded && hidePopup) {
      handleCancel();
      setTimeout(() => {
        setHidePopup(false);
      }, 2000);
    }
  }, [isFetching]);

  useEffect(() => {
    doGetAllGroups();
    doGetAllUsers({ currentPage, itemsPerPage, ...query });
  }, []);

  const handleFilter = (params, updatePath) => {
    if (updatePath) {
      pushTo({ query: params });
    }
    const currentPage = Number(params.currentPage) || 1;
    const itemsPerPage = Number(params.itemsPerPage) || PAGE_SIZE;
    doGetAllUsers({
      currentPage,
      itemsPerPage,
      ...params,
    });
  };

  const handleTableChange = params => {
    handleFilter(params, true);
  };

  const withAction = item => {
    return (
      <div className="actions">
        <Button
          type="link"
          className="edit"
          onClick={() => {
            handleClickAction("edit", item);
          }}>
          <ReactSVG className="icon" src="/icons/edit.svg" />
        </Button>
        <Popconfirm
          title={getTranslation(setting, "Common", "Are you sure to delete this item?")}
          onConfirm={() => handleClickDelete(item)}
          okText={getTranslation(setting, "Common", "Yes")}
          cancelText={getTranslation(setting, "Common", "No")}>
          <Button type="link" className="delete">
            <ReactSVG className="icon" src="/icons/delete.svg" />
          </Button>
        </Popconfirm>
      </div>
    );
  };

  const handleClickDelete = async item => {
    await doDeleteUser(item._id);
    await doGetAllUsers({ currentPage, itemsPerPage, ...query });
  };

  const handleClickAction = (action, item) => {
    form.setFieldsValue({
      name: item?.name,
      email: item?.email,
      groups: item?.groups.map(g => g._id),
      passwordDefault: false,
    });
    setState({
      ...state,
      action,
      type: "user",
      user: item,
      visibleModal: true,
    });
  };

  const handleOnFinish = async values => {
    setHidePopup(true);
    const params = { ...values };
    if (isEmpty(params.password)) delete params.password;
    if (isEmpty(params.groups)) delete params.groups;
    if (state.user) {
      await doUpdateUser({ id: state.user._id, ...params });
    } else {
      await doCreateUser(params);
    }
  };

  const handleCancel = () => {
    setState({ ...state, visibleModal: false });
    form.resetFields();
  };

  const handleClickActionInviteUser = () => {
    form.setFieldsValue({
      group_id: groups[0]?._id,
    });
    setState({
      ...state,
      type: "invite",
      user: null,
      visibleModal: true,
    });
  };

  return (
    <div className="Content UsersPage">
      <RoutePlanCurrent />
      <div className="ContentHeader">
        <div className="HeaderTitle">{getTranslation(setting, "Users", "Users")}</div>
        <div className="HeaderToolBar">
          <div className="ToolBarButtons">
            <Button className="FilterButton" type="primary">
              {getTranslation(setting, "Common", "Filter")}
              <ReactSVG className="icon" src="/icons/filter.svg" />
            </Button>
            {/*<Button
              className="NewButton"
              type="primary"
              onClick={() => {
                handleClickAction("new", null);
              }}
            >
              New User
              <ReactSVG className="icon" src="/icons/add.svg" />
            </Button>*/}
            <PrimaryButton
              label={getTranslation(setting, "Users", "Invite User")}
              className="NewButton"
              icon={<ReactSVG className="icon" src="/icons/add.svg" />}
              onClick={handleClickActionInviteUser}
            />
          </div>
        </div>
      </div>
      <div className="ContentMain">
        <UsersTable
          rowKey="_id"
          loading={isFetching}
          query={query}
          withAction={withAction}
          pagination={pagination}
          dataSource={users}
          onChange2={handleTableChange}
          scrollHeight="calc(100vh - 285px)"
          setting={setting}
        />
      </div>

      <Modal open={state.visibleModal} onCancel={handleCancel} footer={[]} width={state.type === "invite" ? 600 : 370}>
        {state.type === "user" && (
          <UserForm
            form={form}
            isFetching={isFetching}
            user={state.user}
            groups={groups}
            handleSubmit={handleOnFinish}
            handleCancel={handleCancel}
          />
        )}
        {state.type === "invite" && (
          <InviteUserForm
            form={form}
            isFetching={isFetching}
            groups={groups}
            invite={invite}
            doGetGroupInviteEmails={doGetGroupInviteEmails}
            doUpdateGroupInviteEmail={doUpdateGroupInviteEmail}
            doUpdateGroupDisInviteEmail={doUpdateGroupDisInviteEmail}
            doOffGroupInviteEmails={doOffGroupInviteEmails}
          />
        )}
      </Modal>
    </div>
  );
};

export default withPage(ListContainer(UsersPage));
